import { useCallback } from 'react';
import { Source } from '@sodamnfoolish/sjc-backend-types/src/api/feed/dto';
import { ParserBackend } from '../utils/parser-backend';
import { Keypair } from '@solana/web3.js';
import { Api } from '@sodamnfoolish/sjc-backend-types';

const parserBackend = new ParserBackend(process.env.REACT_APP_BACKEND_URL!, process.env.REACT_APP_BACKEND_APIKEY!);

export const useBackend = () => {
    const getSources = useCallback(async () => {
        const sources = await parserBackend.getSources();
        return sources;
    }, []);

    const getPumpFunBubbles = useCallback(async (twitterUsername?: string, size: number = 20) => {
        const bubbles = await parserBackend.getPumpFunBubbles(twitterUsername, size);
        return bubbles;
    }, []);

    const getBonkBubbles = useCallback(async (twitterUsername?: string, size: number = 20) => {
        const bubbles = await parserBackend.getBonkBubbles(twitterUsername, size);
        return bubbles;
    }, []);

    const getFeed = useCallback(async (sources: Source[], size = 20) => {
        const posts = await parserBackend.getFeed(sources, size);
        return posts;
    }, []);

    const getMedia = useCallback(async (id: string) => {
        const media = await parserBackend.getMedia(id);
        return media;
    }, []);

    const getVanity = async () => {
        const vanity = await parserBackend.getVanity();
        return Keypair.fromSecretKey(Uint8Array.from(vanity));
    };

    const getChatGptMetadataFromPostId = async (postId: string) => {
        const chatGptMetadata = await parserBackend.getChatGptMetadataFromPostId(postId);
        return chatGptMetadata;
    };

    const generateTokenMetadataByTweetUrl = async (tweetUrl: string) => {
        console.log('tweet url', tweetUrl);

        const tokenMetadata = await parserBackend.generateTokenMetadataByTweetUrl(encodeURIComponent(tweetUrl));
        return tokenMetadata;
    };

    const generateTokenMetadataByUrl = async (url: string) => {
        console.log('url', url);

        const tokenMetadata = await parserBackend.generateTokenMetadataByUrl(encodeURIComponent(url));
        return tokenMetadata;
    };

    const generateImage = useCallback((generateImageRequest: Api.AI.DTO.GenerateImageRequest) => {
        return parserBackend.generateImage(generateImageRequest);
    }, []);

    const getTokenMetadata = async (mint: string) => {
        const tokenMetadata = await parserBackend.getTokenMetadata(mint);
        return tokenMetadata;
    };

    const sellToken = async (sellRequest: Api.Wallet.DTO.SellRequest, wallet: string) => {
        const signature = await parserBackend.sellToken(sellRequest, wallet);
        return signature;
    };

    const transferToken = async (transferRequest: Api.Wallet.DTO.TransferRequest, wallet: string) => {
        const signature = await parserBackend.transferToken(transferRequest, wallet);
        return signature;
    };

    const deployWithSnipe = async (snipeRequest: Api.Wallet.DTO.DeployWithSniperRequest) => {
        const response = await parserBackend.deployWithSnipe(snipeRequest);
        return response;
    };

    return {
        getSources,
        getPumpFunBubbles,
        getBonkBubbles,
        getFeed,
        getMedia,
        getVanity,
        getChatGptMetadataFromPostId,
        generateTokenMetadataByTweetUrl,
        generateTokenMetadataByUrl,
        generateImage,
        getTokenMetadata,
        sellToken,
        transferToken,
        deployWithSnipe,
    };
};
